export default {
    book: 'Rezerviraj {product}',
    age_limit: 'Samo za osobe starije od {age} godina',
    change_plan: 'Promijeni plan',
    upgrade_product: 'Nadogradi proizvod',
    upgrade: 'Nadogradi',
    cancel_upgrade: 'Otkaži nadogradnju',
    choose_product: 'Odaberi {product}',
    days: '{count} dan | {count} dana',
    login_register: 'Prijava/Registracija',
    current: 'Trenutno',
    keyless_benefits: {
        label: 'Direktno do auta {0}',
        highlight: 'usluga najma™',
        list: {
            cant_lose_the_key: 'Potpuno osiguranje',
            zero_excess: 'Bez franšize',
            phone_as_a_key: 'Mobitel kao ključ',
            straight_to_car: 'Bez čekanja',
            no_queues: 'Bez redova',
            online_id_check: 'Online provjera identiteta',
            self_checkout: 'Samostalna prijava',
        },
    },
};
